import React, { useEffect, useState } from 'react';
import './telecommunication.css';

import buttonArrow from '../../assets/icons/button-arrow.svg';

import telecomHero from '../../assets/telecom-hero.jpg';
import telecomTower from '../../assets/telecom-tower.png';
import { sendContactEmail } from '../../utils/emailjs';

const Telecommunication = () => {
  const [newsletterForm, setNewsletterForm] = useState({
    name: '',
    email: '',
    introduction: '',
  });

  useEffect(() => {
    const previousBackground = document.body.style.background;
    document.body.style.background = '#FFFFFF';
    document.body.classList.add('kw__page-hide-backtotop');

    return () => {
      document.body.style.background = previousBackground;
      document.body.classList.remove('kw__page-hide-backtotop');
    };
  }, []);

  const handleNewsletterChange = (event) => {
    const { name, value } = event.target;
    setNewsletterForm((current) => ({ ...current, [name]: value }));
  };

  const handleNewsletterSubmit = async (event) => {
    event.preventDefault();
    await sendContactEmail(newsletterForm, 'Telecommunication Newsletter');
    setNewsletterForm({
      name: '',
      email: '',
      introduction: '',
    });
  };

  return (
    <div className="kw__telecom-page">
      <section className="kw__telecom-top kw__telecom-section">
        <p className="kw__telecom-outline">Telecommunications</p>
        <h1 className="kw__telecom-title">Keeping Your Digital World Connected</h1>
        <p className="kw__telecom-copy">
          Reliable communication keeps communities safe, businesses agile, and markets integrated. We invest in and operate premier
          telecommunications franchises, leveraging a robust retail footprint to create powerful economies of scale. By optimizing retail operations
          and expanding consumer access points, we lower market barriers and increase connection velocity making us the ideal commercial partner for
          leading service providers looking to scale their retail reach.
        </p>
      </section>

      <section className="kw__telecom-hero-image-wrap">
        <img src={telecomHero} alt="Telecommunications retail" className="kw__telecom-hero-image" />
      </section>

      <section className="kw__telecom-insight-band">
        <div className="kw__telecom-section kw__telecom-insight-inner">
          <div className="kw__telecom-insight-block kw__telecom-insight-block--one">
            <h2>Market Density Managed - Across Expanding Consumer Zones</h2>
            <p>
              We master the complexities of fast-moving retail environments and evolving consumer demand layers. Managing high-volume storefronts,
              point-of-sale operations, and localized subscriber growth requires disciplined operational agility. Our structured franchise management
              ensures that service providers achieve seamless customer acquisition and consistent brand representation across high-traffic commercial
              markets.
            </p>
          </div>

          <div className="kw__telecom-insight-block kw__telecom-insight-block--two">
            <h2>Driving Commercial Scale &amp; Global Connectivity</h2>
            <p>
              Telecommunications relies heavily on market presence the strategic deployment of retail touch points that connect populations to major
              digital networks.
            </p>
            <p>
              Our focus remains on building high-performance retail networks that sustain growth and operational stability under scale. We ensure
              continuous customer traffic, strong brand compliance, and long-term market reliability across expanding territories. This commercial
              platform is purpose-built for global brand partners, investors, and enterprises who understand that network reach only succeeds when
              retail operations hold under continuous market pressure.
            </p>
          </div>
        </div>
      </section>

      <section className="kw__telecom-updates kw__telecom-section">
        <h2 className="kw__telecom-updates-title">Updates from Telecommunications.</h2>
        <p className="kw__telecom-updates-subtitle">Discover more about how we shape industries and empower businesses.</p>

        <div className="kw__telecom-updates-grid">
          <article className="kw__telecom-coming-soon-card" aria-label="Updates coming soon">
            <h3>Coming Soon</h3>
          </article>
        </div>
      </section>

      <section className="kw__telecom-newsletter kw__telecom-section">
        <div className="kw__telecom-newsletter-copy">
          <p className="kw__telecom-newsletter-label">Newsletter</p>
          <h2>Never Miss an Update</h2>
          <p>
            Subscribe to our corporate newsletter to receive quarterly highlights, industry research, and exclusive event invitations directly to your
            inbox.
          </p>

          <form className="kw__telecom-newsletter-form" onSubmit={handleNewsletterSubmit}>
            <div className="kw__telecom-newsletter-row">
              <input name="name" placeholder="Name" value={newsletterForm.name} onChange={handleNewsletterChange} />
              <input name="email" placeholder="Email address" value={newsletterForm.email} onChange={handleNewsletterChange} />
            </div>
            <textarea name="introduction" placeholder="Introduction" value={newsletterForm.introduction} onChange={handleNewsletterChange} />
            <button type="submit" className="kw__telecom-newsletter-submit">
              <span>Submit</span>
              <img src={buttonArrow} alt="" />
            </button>
          </form>
        </div>

        <img src={telecomTower} alt="Telecommunication tower" className="kw__telecom-newsletter-tower" />
      </section>
    </div>
  );
};

export default Telecommunication;
